import { render, staticRenderFns } from "./PaymentsFlux.vue?vue&type=template&id=770b6b34&"
import script from "./PaymentsFlux.vue?vue&type=script&lang=js&"
export * from "./PaymentsFlux.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports